import React, { Suspense } from 'react';

import { useReactNodeView } from '@lyearn/lygo-core';

import PdfLoader from './Loader';
import { ReactPdfProps } from './types';
const ReactPdfLazy = React.lazy(() => import(/* webpackChunkName: "react-pdf" */ './ReactPdf'));
const ReactPdfMicroLearningLazy = React.lazy(
  () => import(/* webpackChunkName: "react-pdf" */ './ReactPdfMicroLearning'),
);

const ReactPdf = (props: ReactPdfProps) => {
  const { isMicroLearning } = useReactNodeView();
  return (
    <Suspense fallback={<PdfLoader />}>
      {isMicroLearning ? <ReactPdfMicroLearningLazy {...props} /> : <ReactPdfLazy {...props} />}
    </Suspense>
  );
};

export default ReactPdf;
